<template>
    <div v-if="shouldPrompt"
         class="push-alert">
        <div class="flex items-center space-x-2">
            <i class="fas fa-bell fa-lg"></i>
            <span class="text-sm">
                Enable push notifications to get updates in real time.
            </span>
        </div>
        <button @click="enablePush"
                class="mx-2 btn btn-info transition">
            Enable
        </button>
        <button @click="dismiss"
                class="btn btn-warning"
                aria-label="Dismiss">
            Close
        </button>
    </div>
</template>


<script setup>
    import { ref, computed, onMounted, watch } from 'vue'
    import { setupFirebasePush } from '../../utils/firebase-push';
    import { useAuthStore } from "../../utils/authStore";


    const pushPermission = ref(Notification.permission)
    const auth = useAuthStore()

    const dismissed = ref(localStorage.getItem('fcm_dismissed') === 'true')
    onMounted(async () => {
        if (auth.user && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
            await setupFirebasePush()
        }
    })



    watch(
        () => auth.user,
        (newUser) => {
            // If user just logged in, re-check push logic
            if (newUser && typeof Notification !== 'undefined' && Notification.permission === 'default' && !dismissed.value) {
                pushPermission.value = Notification.permission
            }
        }
    )

    const shouldPrompt = computed(() =>
        pushPermission.value === 'default' &&
        !dismissed.value &&
        !!auth.user // only show if logged in
    )

    async function enablePush() {
        try {
            dismissed.value = true

            await setupFirebasePush();

            if (typeof Notification !== 'undefined') {
                pushPermission.value = Notification.permission
            }

            localStorage.setItem('fcm_dismissed', 'true')
        } catch (err) {
            console.warn('[Push] Setup failed', err)
        }
    }
    function dismiss() {
        dismissed.value = true
        localStorage.setItem('fcm_dismissed', 'true')
    }
</script>
<style scoped>
    .push-alert {
        position: fixed;
        bottom: 10px;
        right: 2%;
        background: #381459;
        color: #ffffff;
        padding: 0.75rem 1rem;
        border: 1px solid #ffeeba;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 95%;
        max-width: 500px;
    }
</style>
